// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_1fJKS5Lo","tooltipArrow":"_17FpOwy-"};